// modules/branding/defaults.ts
var brandDefaults = {
  // ── Company Identity ────────────────────────────────────────────────────
  companyName: "FirePCR",
  companyLegal: "FirePCR",
  appName: "FirePCR",
  appBrand: "FirePCR",
  domain: "firepcr.com",
  supportEmail: "support@firepcr.com",
  notificationsEmail: "FirePCR <notifications@firepcr.com>",
  // ── Logo & Assets ───────────────────────────────────────────────────────
  logoUrl: "/firepcr-logo.png",
  // ── NEMSIS / EMS Identifiers ────────────────────────────────────────────
  // Agency-specific — must be set via env vars per deployment.
  nemsisAgencyId: "",
  nemsisStateAgencyId: "",
  nemsisStateCode: "",
  nemsisLemsa: "",
  nemsisSoftware: "FirePCR v1.0",
  nemsisSoftwareCreator: "FirePCR",
  // ── Unit Naming Conventions ─────────────────────────────────────────────
  unitPrefixes: {
    ambulance: "AMB",
    medUnit: "MSU",
    rems: "REMS",
    warehouse: "WH",
    truck: "TRK"
  },
  // ── AI Assistant ────────────────────────────────────────────────────────
  assistantName: "Assistant",
  assistantEmoji: "\u{1F525}",
  assistantContext: "You are an AI assistant for a wildfire medical operations team.",
  // ── Legal / Consent Forms ───────────────────────────────────────────────
  consentEntity: "FirePCR",
  hipaaEntity: "FirePCR",
  // ── Scheduling / Ops ────────────────────────────────────────────────────
  schedulerContext: "You are a scheduling assistant for a wildfire medical operations team.",
  // ── Push Notifications ──────────────────────────────────────────────────
  vapidContact: "mailto:support@firepcr.com",
  // ── Documents ───────────────────────────────────────────────────────────
  handbookUrl: ""
  // must be set per deployment
};

// modules/branding/index.ts
var e = import.meta.env ?? process.env;
var brand = {
  // ── Company Identity ────────────────────────────────────────────────────
  companyName: e.VITE_ORG_NAME || brandDefaults.companyName,
  companyLegal: e.VITE_ORG_LEGAL_NAME || brandDefaults.companyLegal,
  appName: e.VITE_APP_NAME || brandDefaults.appName,
  appBrand: e.VITE_APP_BRAND || brandDefaults.appBrand,
  domain: e.VITE_ORG_DOMAIN || brandDefaults.domain,
  supportEmail: e.VITE_SUPPORT_EMAIL || brandDefaults.supportEmail,
  notificationsEmail: e.VITE_NOTIFICATIONS_EMAIL || brandDefaults.notificationsEmail,
  // ── Logo & Assets ───────────────────────────────────────────────────────
  logoUrl: e.VITE_ORG_LOGO_URL || brandDefaults.logoUrl,
  // ── NEMSIS / EMS Identifiers ────────────────────────────────────────────
  nemsisAgencyId: e.VITE_NEMSIS_AGENCY_ID || brandDefaults.nemsisAgencyId,
  nemsisStateAgencyId: e.VITE_NEMSIS_STATE_AGENCY_ID || brandDefaults.nemsisStateAgencyId,
  nemsisStateCode: e.VITE_NEMSIS_STATE_CODE || brandDefaults.nemsisStateCode,
  nemsisLemsa: e.VITE_NEMSIS_LEMSA || brandDefaults.nemsisLemsa,
  nemsisSoftware: e.VITE_NEMSIS_SOFTWARE || brandDefaults.nemsisSoftware,
  nemsisSoftwareCreator: e.VITE_NEMSIS_SOFTWARE_CREATOR || brandDefaults.nemsisSoftwareCreator,
  // ── Unit Naming Conventions ─────────────────────────────────────────────
  unitPrefixes: {
    ambulance: e.VITE_UNIT_PREFIX_AMBULANCE || brandDefaults.unitPrefixes.ambulance,
    medUnit: e.VITE_UNIT_PREFIX_MEDUNIT || brandDefaults.unitPrefixes.medUnit,
    rems: e.VITE_UNIT_PREFIX_REMS || brandDefaults.unitPrefixes.rems,
    warehouse: e.VITE_UNIT_PREFIX_WAREHOUSE || brandDefaults.unitPrefixes.warehouse,
    truck: e.VITE_UNIT_PREFIX_TRUCK || brandDefaults.unitPrefixes.truck
  },
  // ── AI Assistant ────────────────────────────────────────────────────────
  assistantName: e.VITE_ASSISTANT_NAME || brandDefaults.assistantName,
  assistantEmoji: e.VITE_ASSISTANT_EMOJI || brandDefaults.assistantEmoji,
  assistantContext: e.VITE_ASSISTANT_CONTEXT || brandDefaults.assistantContext,
  // ── Legal / Consent Forms ───────────────────────────────────────────────
  consentEntity: e.VITE_CONSENT_ENTITY || brandDefaults.consentEntity,
  hipaaEntity: e.VITE_HIPAA_ENTITY || brandDefaults.hipaaEntity,
  // ── Scheduling / Ops ────────────────────────────────────────────────────
  schedulerContext: e.VITE_SCHEDULER_CONTEXT || brandDefaults.schedulerContext,
  // ── Push Notifications ──────────────────────────────────────────────────
  vapidContact: e.VITE_VAPID_CONTACT || brandDefaults.vapidContact,
  // ── Documents ───────────────────────────────────────────────────────────
  handbookUrl: e.VITE_ORG_HANDBOOK_URL || brandDefaults.handbookUrl
};
export {
  brand
};
